export default __webpack_public_path__ + "static/backgroundOurBranchesRightIllustration-28e5a1bdb33aa851b0c048a6508c6bfc.svg";